import { render, staticRenderFns } from "./AppPageHeader.vue?vue&type=template&id=18fa470a&scoped=true&"
import script from "./AppPageHeader.vue?vue&type=script&lang=js&"
export * from "./AppPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppPageHeader.vue?vue&type=style&index=0&id=18fa470a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fa470a",
  null
  
)

export default component.exports